const moduleNameKey = "singleTextValue";

export const singleTextValueEn = {
  [moduleNameKey]: {
    labelLabel: "Label",
    labelPlaceholder: "Enter label",
    labelRequired: "Pick a label",
    customColorsCheckbox: "Use custom colors",
    labelColorLabel: "Label color",
    valueColorLabel: "Value color",
    lookbackRequired: "Pick a lookback",
    machineLabel: "Machine",
    noMachines: "No machines found",
    machinesPlaceholder: "Search machines...",
    nodeLabel: "Node",
    noNodes: "No nodes found",
    nodesPlaceholder: "Search nodes...",
    unitLabel: "Unit",
    noUnits: "No units found",
    unitsPlaceholder: "Search units...",
    machineRequired: "Pick a machine",
    nodeRequired: "Pick a node",
    scaleInvalid: "Scaling factor must be a number",
    saveButton: "Save",
    cancelButton: "Cancel",
  },
};

export const singleTextValuePtBr = {
  [moduleNameKey]: {
    labelLabel: "Rótulo",
    labelPlaceholder: "Digite o rótulo",
    labelRequired: "Escolha um rótulo",
    customColorsCheckbox: "Usar cores personalizadas",
    labelColorLabel: "Cor do rótulo",
    valueColorLabel: "Cor do valor",
    lookbackRequired: "Selecione um período de leitura",
    machineLabel: "Máquina",
    noMachines: "Nenhuma máquina encontrada",
    machinesPlaceholder: "Buscar máquinas...",
    nodeLabel: "Nó",
    noNodes: "Nenhum nó encontrado",
    nodesPlaceholder: "Buscar nós...",
    unitLabel: "Unidade",
    noUnits: "Nenhuma unidade encontrada",
    unitsPlaceholder: "Buscar unidades...",
    machineRequired: "Selecione uma máquina",
    nodeRequired: "Selecione um nó",
    scaleInvalid: "O fator de escala deve ser um número",
    saveButton: "Salvar",
    cancelButton: "Cancelar",
  },
};

export const singleTextValueDe = {
  [moduleNameKey]: {
    labelLabel: "Beschriftung",
    labelPlaceholder: "Beschriftung eingeben",
    labelRequired: "Eine Beschriftung wählen",
    customColorsCheckbox: "Eigene Farben verwenden",
    labelColorLabel: "Beschriftungsfarbe",
    valueColorLabel: "Wertfarbe",
    lookbackRequired: "Rückblick auswählen",
    machineLabel: "Maschine",
    noMachines: "Keine Maschinen gefunden",
    machinesPlaceholder: "Maschinen suchen...",
    nodeLabel: "Knoten",
    noNodes: "Keine Knoten gefunden",
    nodesPlaceholder: "Knoten suchen...",
    unitLabel: "Einheit",
    noUnits: "Keine Einheiten gefunden",
    unitsPlaceholder: "Einheiten suchen...",
    machineRequired: "Maschine auswählen",
    nodeRequired: "Knoten auswählen",
    scaleInvalid: "Der Skalierungsfaktor muss eine Zahl sein",
    saveButton: "Speichern",
    cancelButton: "Abbrechen",
  },
};

export const singleTextValueZhHans = {
  [moduleNameKey]: {
    labelLabel: "标签",
    labelPlaceholder: "输入标签",
    labelRequired: "请选择一个标签",
    customColorsCheckbox: "使用自定义颜色",
    labelColorLabel: "标签颜色",
    valueColorLabel: "值颜色",
    lookbackRequired: "选择回溯时间",
    machineLabel: "机器",
    noMachines: "未找到机器",
    machinesPlaceholder: "搜索机器...",
    nodeLabel: "节点",
    noNodes: "未找到节点",
    nodesPlaceholder: "搜索节点...",
    unitLabel: "单位",
    noUnits: "未找到单位",
    unitsPlaceholder: "搜索单位...",
    machineRequired: "选择机器",
    nodeRequired: "选择节点",
    scaleInvalid: "缩放系数必须为数字",
    saveButton: "保存",
    cancelButton: "取消",
  },
};

export const singleTextValueIt = {
  [moduleNameKey]: {
    labelLabel: "Etichetta",
    labelPlaceholder: "Inserisci etichetta",
    labelRequired: "Seleziona un'etichetta",
    customColorsCheckbox: "Usa colori personalizzati",
    labelColorLabel: "Colore etichetta",
    valueColorLabel: "Colore del valore",
    lookbackRequired: "Seleziona un periodo di osservazione",
    machineLabel: "Macchina",
    noMachines: "Nessuna macchina trovata",
    machinesPlaceholder: "Cerca macchine...",
    nodeLabel: "Nodo",
    noNodes: "Nessun nodo trovato",
    nodesPlaceholder: "Cerca nodi...",
    unitLabel: "Unità",
    noUnits: "Nessuna unità trovata",
    unitsPlaceholder: "Cerca unità...",
    machineRequired: "Seleziona una macchina",
    nodeRequired: "Seleziona un nodo",
    scaleInvalid: "Il fattore di scala deve essere un numero",
    saveButton: "Salva",
    cancelButton: "Annulla",
  },
};

export const singleTextValueEs = {
  [moduleNameKey]: {
    labelLabel: "Etiqueta",
    labelPlaceholder: "Introducir etiqueta",
    labelRequired: "Elija una etiqueta",
    customColorsCheckbox: "Usar colores personalizados",
    labelColorLabel: "Color de la etiqueta",
    valueColorLabel: "Color del valor",
    lookbackRequired: "Seleccione un período de búsqueda",
    machineLabel: "Máquina",
    noMachines: "No se encontraron máquinas",
    machinesPlaceholder: "Buscar máquinas...",
    nodeLabel: "Nodo",
    noNodes: "No se encontraron nodos",
    nodesPlaceholder: "Buscar nodos...",
    unitLabel: "Unidad",
    noUnits: "No se encontraron unidades",
    unitsPlaceholder: "Buscar unidades...",
    machineRequired: "Seleccione una máquina",
    nodeRequired: "Seleccione un nodo",
    scaleInvalid: "El factor de escala debe ser un número",
    saveButton: "Guardar",
    cancelButton: "Cancelar",
  },
};

export const singleTextValueNl = {
  [moduleNameKey]: {
    labelLabel: "Label",
    labelPlaceholder: "Voer een label in",
    labelRequired: "Kies een label",
    customColorsCheckbox: "Aangepaste kleuren gebruiken",
    labelColorLabel: "Labelkleur",
    valueColorLabel: "Waardekleur",
    lookbackRequired: "Kies een terugkijkperiode",
    machineLabel: "Machine",
    noMachines: "Geen machines gevonden",
    machinesPlaceholder: "Machines zoeken...",
    nodeLabel: "Knooppunt",
    noNodes: "Geen knooppunten gevonden",
    nodesPlaceholder: "Knooppunten zoeken...",
    unitLabel: "Eenheid",
    noUnits: "Geen eenheden gevonden",
    unitsPlaceholder: "Eenheden",
    machineRequired: "Kies een machine",
    nodeRequired: "Kies een knooppunt",
    scaleInvalid: "De schaalfactor moet een getal zijn",
    saveButton: "Opslaan",
    cancelButton: "Annuleren",
  },
};

export const singleTextValueTr = {
  [moduleNameKey]: {
    labelLabel: "Etiket",
    labelPlaceholder: "Etiket girin",
    labelRequired: "Bir etiket seçin",
    customColorsCheckbox: "Özel renkler kullan",
    labelColorLabel: "Etiket rengi",
    valueColorLabel: "Değer rengi",
    lookbackRequired: "Bir yeniden inceleme seçin",
    machineLabel: "Makine",
    noMachines: "Hiçbir makine bulunamadı",
    machinesPlaceholder: "Arama makineleri...",
    nodeLabel: "Düğüm",
    noNodes: "Hiçbir düğüm bulunamadı",
    nodesPlaceholder: "Düğümleri ara...",
    unitLabel: "Birim",
    noUnits: "Birim bulunamadı",
    unitsPlaceholder: "Birimleri arayın...",
    machineRequired: "Bir makine seç",
    nodeRequired: "Bir düğüm seç",
    scaleInvalid: "Ölçek faktörü bir sayı olmalıdır",
    saveButton: "Kaydetmek",
    cancelButton: "İptal etmek",
  },
};
